import { config } from '@iheartjane/config';

const getAlgoliaEnv = () => config.algoliaEnv;

export const MENU_PRODUCTS_BY_PRICE_ASC = `menu-products-by-price-${getAlgoliaEnv()}`;

export const STORE_DEFAULT = `stores-${getAlgoliaEnv()}`;
